import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/grow-on-x/content.tsx");
